import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import Cookie from "js-cookie";
import { checkEnableMT5 } from "./utils/helper";

Vue.use(Router);

var router = new Router({
  mode: "history",
  base: process.env.VUE_APP_PATH,
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/login",
      component: () => import(/* webpackChunkName: "login" */ "@/view/login/Login.vue"),
    },
    {
      path: "/token",
      component: () => import(/* webpackChunkName: "token" */ "@/view/module/Token.vue"),
    },
    {
      path: "/forgetPwd",
      component: () => import(/* webpackChunkName: "forgetPwd" */"@/view/login/ForgetPwd.vue"),
    },
    {
      path: "/forgetPwdAcc",
      component: () => import(/* webpackChunkName: "forgetPwdAcc" */ "@/view/login/ForgetPwdAcc.vue"),
    },
    {
      path: "/setPasswordByEmail",
      component: () => import(/* webpackChunkName: "setPasswordByEmail" */ "@/view/login/SetPasswordByEmail.vue"),
    },
    {
      path: "/addMT5Result",
      component: () => import(/* webpackChunkName: "addMT5Result" */ "@/view/addMT5/AddMT5Result.vue"),
    },
    {
      path: "/home",
      component: () => import(/* webpackChunkName: "initData" */ "@/view/InitData.vue"),
      meta: {
        userAuth: true,
      },
      children: [
        {
          path: "",
          component: () => import(/* webpackChunkName: "index" */ "@/view/home/Index.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "recordDetail",
          name: "recordDetail",
          component: () => import("@/view/record/RecordDetail.vue"),
        },
        {
          path: "personalCenter",
          component: () => import(/* webpackChunkName: "personalCenter" */ "@/view/home/PersonalCenter.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "accOverview",
          component: () => import(/* webpackChunkName: "accOverview" */ "@/view/home/AccOverview.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "addWeChat",
          component: () => import(/* webpackChunkName: "accAddWeChat" */ "@/view/home/AccAddWeChat.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "addTelegram",
          component: () => import(/* webpackChunkName: "accAddTelegram" */ "@/view/home/AccAddTelegram.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "addX",
          component: () => import(/* webpackChunkName: "accAddX" */ "@/view/home/AccAddX.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "addDingTalk",
          component: () => import(/* webpackChunkName: "accAddDingTalk" */ "@/view/home/AccAddDingTalk.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "accLevel",
          component: () => import(/* webpackChunkName: "accLevel" */ "@/view/home/AccLevel.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "accInfo",
          component: () => import(/* webpackChunkName: "accInfo" */ "@/view/home/AccInfo.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "accUpgrade",
          component: () => import(/* webpackChunkName: "accUpgrade" */ "@/view/home/AccUpgrade.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "accUpdatePersonalData",
          component: () => import(/* webpackChunkName: "accUpdatePersonalData" */ "@/view/home/AccUpdatePersonalData.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "modifyPwd",
          component: () => import(/* webpackChunkName: "modifyPwd" */ "@/view/login/ModifyPwd.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "referral",
          component: () => import(/* webpackChunkName: "referral" */ "@/view/referral/Referral.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "success",
          component: () => import(/* webpackChunkName: "success" */ "@/view/module/Success.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "personalInfo",
          component: () => import(/* webpackChunkName: "personalInfo" */ "@/view/personalInfo/PersonalInfo.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "credentials",
          component: () => import(/* webpackChunkName: "credentials" */ "@/view/personalInfo/Credentials.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "address",
          component: () => import(/* webpackChunkName: "address" */ "@/view/personalInfo/Address.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "identity",
          component: () => import(/* webpackChunkName: "identity" */ "@/view/personalInfo/Identity.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "faceValidate",
          component: () => import(/* webpackChunkName: "faceValidate" */ "@/view/personalInfo/FaceValidate.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "addBankCard",
          component: () => import(/* webpackChunkName: "addBankCard" */ "@/view/bankCard/AddBankCard.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "uploadProof",
          component: () => import(/* webpackChunkName: "uploadProof" */ "@/view/bankCard/UploadProof.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "bankList",
          component: () => import(/* webpackChunkName: "bankList" */ "@/view/bankCard/BankList.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "addBankBranch",
          component: () => import(/* webpackChunkName: "addBankBranch" */ "@/view/bankCard/AddBankBranch.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "eWalletList",
          component: () => import(/* webpackChunkName: "eWalletList" */ "@/view/ewallet/EwalletList.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "problem",
          component: () => import(/* webpackChunkName: "problem" */ "@/view/bankCard/Problem.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "recharge",
          component: () => import(/* webpackChunkName: "recharge" */ "@/view/recharge/Recharge.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "rechargeConfirm",
          component: () => import(/* webpackChunkName: "rechargeConfirm" */ "@/view/recharge/RechargeConfirm.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "rechargeDictConfirm",
          component: () => import(/* webpackChunkName: "rechargeDictConfirm" */ "@/view/recharge/RechargeDictConfirm.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "iviPayMobile",
          component: () => import(/* webpackChunkName: "iviPayMobile" */ "@/view/recharge/IviPayMobile.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "rechargeResult",
          component: () => import(/* webpackChunkName: "rechargeResult" */ "@/view/recharge/RechargeResult.vue"),
        },
        {
          path: "rechargeQRCode",
          component: () => import(/* webpackChunkName: "rechargeQRCode" */ "@/view/recharge/RechargeQRCode.vue"),
        },
        {
          path: "withdrawal",
          component: () => import(/* webpackChunkName: "withdrawal" */ "@/view/withdrawal/Withdrawal.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "withdrawalConfirm",
          component: () => import(/* webpackChunkName: "withdrawalConfirm" */ "@/view/withdrawal/WithdrawalConfirm.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "withdrawalResult",
          component: () => import(/* webpackChunkName: "withdrawalResult" */ "@/view/withdrawal/WithdrawalResult.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "registerUSDT",
          component: () => import(/* webpackChunkName: "registerUSDT" */ "@/view/withdrawal/RegisterUSDT.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "record",
          name: "record",
          component: () => import(/* webpackChunkName: "record" */ "@/view/record/Record.vue"),
          meta: {
            userAuth: true,
            keepAlive: true,
          },
        },
        {
          path: "uploadDocuments",
          name: "uploadDocuments",
          component: () => import(/* webpackChunkName: "uploadDocuments" */ "@/view/record/UploadDocuments.vue"),
          meta: {
            userAuth: true,
            keepAlive: true,
          },
        },
        {
          path: "recordDetail",
          name: "recordDetail",
          component: () => import(/* webpackChunkName: "recordDetail" */ "@/view/record/RecordDetail.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "paySettings",
          component: () => import(/* webpackChunkName: "paySettings" */ "@/view/paySettings/PaySettings.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "report",
          component: () => import(/* webpackChunkName: "report" */ "@/view/report/Report.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "urgentClose",
          component: () => import(/* webpackChunkName: "urgentClose" */ "@/view/urgentClose/UrgentClose.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "urgentRecord",
          component: () => import(/* webpackChunkName: "urgentRecord" */ "@/view/urgentClose/UrgentRecord.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "messageCenter",
          component: () => import(/* webpackChunkName: "messageCenter" */ "@/view/messageCenter/MessageCenter.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "messageDetail",
          component: () => import(/* webpackChunkName: "messageDetail" */ "@/view/messageCenter/MessageDetail.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "external",
          component: () => import(/* webpackChunkName: "external" */ "@/view/Iframe/External.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "tickData",
          component: () => import(/* webpackChunkName: "tickData" */ "@/view/tickData/TickData.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "platformTransfer",
          component: () =>
            import(/* webpackChunkName: "platformTransfer" */ "@/view/platformTransfer/PlatformTransfer.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "platformTransferConfirm",
          component: () =>
            import(/* webpackChunkName: "platformTransferConfirm" */ "@/view/platformTransfer/PlatformTransferConfirm.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "platformTransferResult",
          component: () =>
            import(/* webpackChunkName: "platformTransferResult" */ "@/view/platformTransfer/PlatformTransferResult.vue"),
          meta: {
            userAuth: true,
          },
        },
        {
          path: "addMT5CheckPassword",
          component: () => import(/* webpackChunkName: "addMT5CheckPassword" */ "@/view/addMT5/AddMT5CheckPassword.vue"),
          meta: {
            userAuth: true,
          },
        },
      ],
    },
  ],
});

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

router.beforeEach((to, from, next) => {
  if (from.name == "recordDetail" && to.name == "record") {
    store.dispatch("setKeepAlive", 1);
  } else store.dispatch("setKeepAlive", 0);
  if (to.query.pageType) store.dispatch("setPageType", to.query.pageType);
  if (to.query.appVerName) store.dispatch("setVersion", to.query.appVerName);
  if (to.query.pageType == "app") {
    if (to.query.sourceType == "old") {
      store.dispatch("setSourceType", to.query.sourceType);
      if (to.query.token) {
        next({
          path: "/token",
          query: { url: to.path, loginToken: to.query.token, query: to.query },
        });
        store.dispatch("setToken", to.query.token);
      }
      // 访问主页但未登录
      else if (to.meta.userAuth && !store.state.user.loginname) {
        next({ path: "/login" });
      }
      // 访问登录页但已登录过
      else if (
        (to.fullPath.startsWith("/Login") ||
          to.fullPath.startsWith("/login")) &&
        store.state.user.loginname
      ) {
        next({ path: "/home" });
      }
      next();
    } else {
      if (to.query.accountNo) {
        if (
          !localStorage.getItem("customerNumber") ||
          localStorage.getItem("customerNumber") == null ||
          localStorage.getItem("customerNumber") == "" ||
          typeof localStorage.getItem("customerNumber") == "undefined"
        ) {
          store.dispatch("setCustomerNumber", to.query.accountNo);
        } else if (
          JSON.parse(localStorage.getItem("customerNumber")) !=
          to.query.accountNo
        ) {
          localStorage.clear();
          Cookie.remove("tokenCookie");
          Cookie.remove("m-userCenter");
        }
      }
      if (
        !Cookie.get("tokenCookie") ||
        Cookie.get("tokenCookie") == null ||
        Cookie.get("tokenCookie") == "" ||
        typeof Cookie.get("tokenCookie") == "undefined" ||
        Cookie.get("tokenCookie") == "{}"
      ) {
        if (to.query.token) {
          next({
            path: "/token",
            query: {
              url: to.path,
              loginToken: to.query.token,
              query: to.query,
            },
          });
          store.dispatch("setToken", to.query.token);
          store.dispatch("setTokenCookie", to.query.token);
        }
      } else if (Cookie.get("tokenCookie")) {
        next({
          path: "/token",
          query: {
            url: to.path,
            loginToken: JSON.parse(Cookie.get("tokenCookie")),
            query: to.query,
          },
        });
        store.dispatch("setToken", JSON.parse(Cookie.get("tokenCookie")));
      }
      // 访问主页但未登录
      else if (to.meta.userAuth && !store.state.user.loginname) {
        next({ path: "/login" });
      }
      // 访问登录页但已登录过
      else if (
        (to.fullPath.startsWith("/Login") ||
          to.fullPath.startsWith("/login")) &&
        store.state.user.loginname
      ) {
        next({ path: "/home" });
      }
      next();
    }
  } else {
    if (to.query.token) {
      next({
        path: "/token",
        query: { url: to.path, loginToken: to.query.token, query: to.query },
      });
      store.dispatch("setToken", to.query.token);
    }
    // 访问主页但未登录
    else if (to.meta.userAuth && !store.state.user.loginname) {
      next({ path: "/login" });
    }
    // 访问登录页但已登录过
    else if (
      (to.fullPath.startsWith("/Login") || to.fullPath.startsWith("/login")) &&
      store.state.user.loginname
    ) {
      next({ path: "/home" });
    }
    next();
  }
});

router.afterEach((to) => {
  checkEnableMT5(to.query);
});

export default router;